import {pullRequestFileTreeWidthSettingPath, userPRFileTreeVisibilitySettingPath} from '@github-ui/paths'
import {verifiedFetch} from '@github-ui/verified-fetch'

export type FileTreePreferenceUser = {
  login: string
}

export type FileTreeWidthContext = {
  owner: string
  repo: string
  pullNumber: number
}

export async function updateFileTreePreference(treeValue: boolean, currentUser?: FileTreePreferenceUser) {
  if (!currentUser) {
    return
  }

  const formData = new FormData()
  formData.set('file_tree_visible', treeValue ? 'true' : 'false')

  verifiedFetch(userPRFileTreeVisibilitySettingPath(currentUser), {
    method: 'PUT',
    body: formData,
    headers: {Accept: 'application/json'},
  })
}

export async function updateFileTreeWidth(width: number, context?: FileTreeWidthContext) {
  if (!context) {
    return
  }

  const formData = new FormData()
  formData.set('file_tree_width', String(width))

  verifiedFetch(pullRequestFileTreeWidthSettingPath(context), {
    method: 'POST',
    body: formData,
    headers: {Accept: 'application/json'},
  })
}
